'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.company_create', {
    url: '/company_create',
    template: '<company-create></company-create>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/company/create/company_create.route.js